import { TDictionaryItem } from '../types'
import { TOption } from '../../../core/components/CustomSelect'

export function prepareOptions(items?: TDictionaryItem[]): TOption[] {
  return items?.map(({ id, type, value, code }) => ({
    value: code,
    label: value
  })) ?? []
}
